export enum StoreType {
    Card = "card",    
    Board = "board",
    Member = "member",
    Organization = "organization"    
}

export enum StoreScope {
    Shared = "shared",
    Private = "private"
}

export interface TrelloStoreFrom {
    
    in(cardId: string, storeScope: StoreScope) : TrelloStoreMethod;

    setCardShared(key:string, value: any) : Promise<any>;
    setCardPrivate(key:string, value: any) : Promise<any>;
    setBoardShared(key:string, value: any) : Promise<any>;
    setBoardPrivate(key:string, value: any) : Promise<any>;
    setMemberShared(key:string, value: any) : Promise<any>;
    setMemberPrivate(key:string, value: any) : Promise<any>;

    removeCardShared(key:string) : Promise<any>;
    removeCardPrivate(key:string) : Promise<any>;
    removeBoardShared(key:string) : Promise<any>;
    removeBoardPrivate(key:string) : Promise<any>;
    removeMemberShared(key:string) : Promise<any>;
    removeMemberPrivate(key:string) : Promise<any>;

    getCardShared(key:string) : Promise<any>;
    getCardPrivate(key:string) : Promise<any>;
    getBoardShared<T>(key:string) : Promise<T>;
    getBoardPrivate(key:string) : Promise<any>;
    getMemberShared(key:string) : Promise<any>;
    getMemberPrivate(key:string) : Promise<any>;
}

export interface TrelloStoreMethod {
    get(key: string) : Promise<any>;
    set(keyOrKeyValuePairObject: any, value?: any) : Promise<any>;
    remove(...keys: string[]): Promise<any>;
}

export class TrelloStore {
    public using(t: any) : TrelloStoreFrom { 
        return new TrelloStoreUsingImpl(t); 
    }  
}

class TrelloStoreUsingImpl implements TrelloStoreFrom, TrelloStoreMethod {
    
    setCardShared(key: string, value: any): Promise<any> {
        return this.in(StoreType.Card,StoreScope.Shared).set(key,value);
    }
    setCardPrivate(key: string, value: any): Promise<any> {
        return this.in(StoreType.Card,StoreScope.Private).set(key,value);
    }
    setBoardShared(key: string, value: any): Promise<any> {
        return this.in(StoreType.Board,StoreScope.Shared).set(key,value);
    }
    setBoardPrivate(key: string, value: any): Promise<any> {
        return this.in(StoreType.Board,StoreScope.Private).set(key,value);
    }
    setMemberShared(key: string, value: any): Promise<any> {
        return this.in(StoreType.Member,StoreScope.Shared).set(key,value);
    }
    setMemberPrivate(key: string, value: any): Promise<any> {
        return this.in(StoreType.Member,StoreScope.Private).set(key,value);
    }

    getCardShared(key: string): Promise<any> {
        return this.in(StoreType.Card,StoreScope.Shared).get(key);
    }
    getCardPrivate(key: string): Promise<any> {
        return this.in(StoreType.Card,StoreScope.Private).get(key);
    }
    getBoardShared(key: string): Promise<any> {
        return this.in(StoreType.Board,StoreScope.Shared).get(key);
    }
    getBoardPrivate(key: string): Promise<any> {
        return this.in(StoreType.Board,StoreScope.Private).get(key);
    }
    getMemberShared(key: string): Promise<any> {
        return this.in(StoreType.Member,StoreScope.Shared).get(key);
    }
    getMemberPrivate(key: string): Promise<any> {
        return this.in(StoreType.Member,StoreScope.Private).get(key);
    }

    removeCardShared(key: string): Promise<any> {
        return this.in(StoreType.Card,StoreScope.Shared).remove(key);
    }
    removeCardPrivate(key: string): Promise<any> {
        return this.in(StoreType.Card,StoreScope.Private).remove(key);
    }
    removeBoardShared(key: string): Promise<any> {
        return this.in(StoreType.Board,StoreScope.Shared).remove(key);
    }
    removeBoardPrivate(key: string): Promise<any> {
        return this.in(StoreType.Board,StoreScope.Private).remove(key);
    }
    removeMemberShared(key: string): Promise<any> {
        return this.in(StoreType.Member,StoreScope.Shared).remove(key);
    }
    removeMemberPrivate(key: string): Promise<any> {
        return this.in(StoreType.Member,StoreScope.Private).remove(key);
    }
    
    private t:any;
    private storeType: any;
    private storeScope: StoreScope;

    constructor(t:any, storeType?: any, storeScope?: StoreScope)
    constructor(t:any, storeType: any, storeScope: StoreScope) { 
        this.t = t; 
        this.storeType = storeType;
        this.storeScope = storeScope;
    }

    public using(t: any) : TrelloStoreFrom { 
        return new TrelloStoreUsingImpl(t); 
    }

    public in(storeType: StoreType, storeScope: StoreScope) : TrelloStoreMethod;
    public in(cardId: string, storeScope: StoreScope) : TrelloStoreMethod {
        return new TrelloStoreUsingImpl(this.t,cardId, storeScope);
    }

    public get(key: string): Promise<any>  {
        var st = this.storeType.toString();
        var ss = this.storeScope.toString().toLocaleLowerCase();
        return this.t.get(st,ss,key);
    }

    public set(keyOrKeyValuePairObject: any, value?: any): Promise<any>  {
        var st = this.storeType.toString();
        var ss = this.storeScope.toString().toLocaleLowerCase(); 
        if (value) {
            return this.t.set(st,ss,keyOrKeyValuePairObject,value);
        }
        else {
            return this.t.set(st,ss,keyOrKeyValuePairObject);
        }
    }

    public remove(...keys: string[]): Promise<any>  {
        var st = this.storeType.toString();
        var ss = this.storeScope.toString().toLocaleLowerCase();
        return this.t.remove(st, ss, keys); 
    }
}


export var trelloStore = function(t: any): TrelloStoreFrom { return new TrelloStore().using(t); }
export default trelloStore;